<template>
  <div class="checkbox-wrapper">
    <div class="checkbox" @click="handleCheckboxClick">
      <div class="box">
        <div class="indicator" :class="{ selected: chbxVal }"></div>
      </div>
      <span class="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    chbxVal: false
  }),
  watch: {
    value(val) {
      this.chbxVal = val;
    }
  },
  created() {
    this.chbxVal = this.value;
  },
  methods: {
    handleCheckboxClick() {
      this.chbxVal = !this.chbxVal;
      this.$emit("toggled");
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  color: $gray-700;
  cursor: pointer;
  font-size: $font-size-xs;
  font-weight: 500;
  margin-bottom: 10px;
  .checkbox {
    align-items: flex-start;
    display: flex;
    .box {
      background-color: #fff;
      border: 1px solid #505050;
      height: 15px;
      margin-right: 10px;
      padding: 2px;
      position: relative;
      width: 15px;
      .indicator {
        background-color: var(--primary, $brand-primary);
        bottom: 0;
        left: 0;
        height: 100%;
        position: relative;
        right: 0;
        top: 0;
        transition: all 0.1s ease-in-out;
        transform: scale(0);
        width: 100%;
        &.selected {
          transform: scale(1);
        }
      }
    }
    span {
      font-family: "Gotham", sans-serif;
    }
  }
}
</style>
